import { makeStyles } from '@mui/styles';
import Typography from 'apollo-react/components/Typography';
import StatusExclamation from 'apollo-react-icons/StatusExclamation';
import React from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    backgroundColor: '#fff',
  },
  text: {
    padding: 5,
  },
});

const PreventMountMessage = () => {
  const classes = useStyles();
  const translateString = useTranslation();

  return (
    <div className={classes.root}>
      <StatusExclamation fontSize="large" />
      <Typography variant="title2" className={classes.text}>
        {translateString(
          'Form load has been terminated. Refer to the error message for additional details.'
        )}
      </Typography>
    </div>
  );
};
export default PreventMountMessage;
